import React from "react";
import autoBind from "auto-bind";

class BaseComponent extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
}

export default BaseComponent;
